import React from "react";
import classes from "./Toolbar.css";
import Logo from "../../Logo/Logo";
import NavigationItems from "../NavigationItems/NavigationItems";
import DrawerToogle from "../SideDrawer/DrawerToogle/DrawerToogle";

const toolbar = (props) => (
  <header className={classes.Toolbar}>
    <DrawerToogle clicked={props.drawerToogleClicked} />
    <div className={classes.Logo}>
      <Logo />
    </div>
    <nav className={classes.DesktopOnly}>
      <NavigationItems isAuthenticated={props.isAuth} />
    </nav>
  </header>
);
export default toolbar;



// WEBPACK FOOTER //
// ./src/components/Navigation/Toolbar/Toolbar.js